import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { selectSystem, checkAnalyticsAccess } from '../actions';
import { withOktaAuth } from '@okta/okta-react';
import { fetchUserProfileData } from '../actions/profile/profile.action';

//import HeaderFilterBs from './HeaderFilterBs';


class HeaderBs extends React.Component {
    createDropDown() {
        //let systemsLength = this.props.systems;
        return this.props.systems.map((system) => {
            return (
                <div key={system.id} style={{ textAlign: 'center' }}>
                    <a onClick={() => this.props.selectSystem(system)}>
                        <p>{system.sysName} - {system.amount}</p>
                    </a>
                    <div className="dropdown-divider"></div>
                </div>
            );
        });
    }

    //fetch latest data and pass auth Obj with tokens for API call
    checkUserAccess = async () => {
        let authObj = {};
        if (this.props.authState.isAuthenticated) {
            const userInfo = await this.props.oktaAuth.getUser();
            authObj.curUserInfo = userInfo;
            authObj.token = this.props.authState.accessToken;
            //Action to check if user has analytics access
            await this.props.checkAnalyticsAccess(authObj.token);
            await this.props.fetchUserProfileData(authObj.token);

        }
    };

    componentDidMount() {
        if (Object.keys(this.props.user).length === 0) {
            this.checkUserAccess();
        }
    }

    render() {

        let updatedTime = new Date();
        updatedTime = updatedTime.toString();
        // eslint-disable-next-line
        updatedTime = updatedTime.replace(/GMT.*/g, '');

        return (
            <div className="main-header" style={{ fontFamily: 'interBoldUI' }}>
                {/* <!-- Logo Header --> */}
                <div className="logo-header" data-background-color="white">
                    <a href="/" className="logo" id="logoHeader">
                        <img src="../assets/img/intuitive_logo_black.png" alt="navbar brand"
                            className="navbar-brand"></img>
                    </a>
                    {/* <button className="navbar-toggler sidenav-toggler ml-auto" type="button" data-toggle="collapse" data-target="collapse" aria-expanded="false" aria-label="Toggle navigation" onClick={()  => {
                            console.log("Clicked left hamburger menu");
                        }}>
                            <span className="navbar-toggler-icon">
                                <i className="icon-menu"></i>
                            </span>
                        </button> */}
                    <MediaQuery maxDeviceWidth={1224}>
                        <div className="dropdown">
                            <button className="btn dropdown-toggle" style={{ color: 'black' }} type="button"
                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                {this.props.curSystem.sysName}
                            </button>
                            <div style={{ minWidth: '7rem' }} className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton">
                                {this.createDropDown()}
                            </div>
                        </div>
                    </MediaQuery>
                    {/* <button className="topbar-toggler more" onClick={() => {console.log("clicked 3 button right menu")}}><i className="icon-options-vertical"></i></button> */}
                    {/* <div className="nav-toggle">
                            <button className="btn btn-toggle toggle-sidebar">
                                <i className="icon-menu"></i>
                            </button>
                        </div> */}
                </div>
                {/* <div className="container-fluid">
                        <div className="page-inner mt--5">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card full-height">
                                        <HeaderFilterBs/>
                                    </div>
                                </div>
                            </div>
                        </div>
                     </div> */}
                <nav className="navbar navbar-header navbar-expand-lg" data-background-color="white">

                    <div className="container-fluid">
                        <h2 className="text-black pb-2 fw-bold" id="appName">ISI Anywhere</h2>

                        <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                            {/* <li className="nav-item dropdown hidden-caret">
                                <h2 className="text-black pb-2 fw-bold" id='appName'>ISI Anywhere</h2>
                            </li> */}
                            <li className="nav-item dropdown hidden-caret">
                                <h4 className="" id="totalCountText">
                                    You have {this.props.systems[0].amount} Total Notifications
                                    <br></br>
                                    <small className="text-muted" id="updateTimeText">Updated: {updatedTime}</small>
                                </h4>
                            </li>
                            {/* <li>
                                <Link to="/about">
                                    <a href="/about" target="_blank" className="fas fa-question-circle" data-toggle="modal" data-target="#exampleModalCenter" style={{ paddingLeft: "10px" }} title="About/Help" ></a>
                                </Link>
                            </li> */}
                            <li className="nav-item dropdown hidden-caret submenu show">
                                <a className="dropdown-toggle profile-pic" id="dropdownMenuButton" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <div className="avatar-sm">
                                        <img src="/assets/img/profile_placeholder.png" alt="..."
                                            className="avatar-img rounded-circle"></img>
                                    </div>
                                </a>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    {/* If use has analytics access show menu item */}
                                    {this.props.hasAnalyticsAccess === true &&
                                        <a className="dropdown-item" href="/analytics">Analytics</a>
                                    }
                                    {
                                        this.props.userProfile?.roles?.indexOf('admin') >= 0 &&
                                        (<a className="dropdown-item" href="/admin">Admin</a>)
                                    }
                                    <a className="dropdown-item" href="/about">About</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        systems: state.systems,
        curSystem: state.selectedSystem,
        hasAnalyticsAccess: state.analyticsAccess,
        user: state.user,
        userProfile: state.userProfile.profile,
    };
};

export default connect(mapStateToProps, {
    selectSystem,
    checkAnalyticsAccess,
    fetchUserProfileData,
})(withOktaAuth(HeaderBs));